// src/components/home/ContentSection.jsx
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router';

const ContentSection = ({ 
  eyebrow, 
  heading, 
  description, 
  imagePosition, 
  bgColor,
  imageUrl,
  buttonText,link,
  index 
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const navigate=useNavigate();
  const content = (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <span className="text-brand-orange text-sm font-semibold tracking-wider">{eyebrow}</span>
      <h3 className="text-4xl font-bold text-gray-900 mt-4 mb-6">{heading}</h3>
      <p className="text-gray-600 text-lg leading-relaxed">{description}</p>
      {buttonText && (
        <motion.button
          whileHover={{ scale: 1.05 }}
onClick={() => window.open(link, "_blank")}
          className="mt-8 px-6 py-3 bg-brand-orange text-white rounded-lg font-medium hover:bg-brand-orange-dark transition-colors duration-300"
        >
          {buttonText}
        </motion.button>
      )}
    </motion.div>
  );

  const image = (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={inView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.6 }}
      className="rounded-2xl shadow-xl overflow-hidden"
    >
      <div className="aspect-[4/3] w-full overflow-hidden rounded-2xl">
        <motion.img
          src={imageUrl}
          alt={heading}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.4 }}
        />
      </div>
    </motion.div>
  );

  return (
    <section className={`py-20 ${bgColor}`}>
      <div ref={ref} className="max-w-8xl mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {imagePosition === 'left' ? (
            <>
              {image}
              {content}
            </>
          ) : (
            <>
              {content}
              {image}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;